import React from 'react';
import { Select, Input, AutoComplete, Button, Form, Icon, Tooltip, Avatar, message, Switch, Popconfirm, Popover } from 'antd';
import SERVER_URL from '../Global';
import { Row, Col } from 'reactstrap';
import HandleHr from './HandleHr';

const { Option } = Select;

message.config({
    top: 100,
    duration: 2,
    maxCount: 1
});

class HandleRole extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            user: this.props.user,
            officeId: this.props.office,
            loading: true,
            hroidCreated: false,
            roleCreated: false,
            roleDeleted: false,
            properties: this.props.properties,
            companies: [],
            contactsHr: ['0'],
            contactHrId: 0,
            roleName: null,
            hrId: '',
            hroId: '',
            hrContactText: '',
            roleId: '',
            isHr: true,
            companyId: '',
            newHr: ['0'],
            newHrId: 1,
            collabId: '',
            basicHroid: '',
            roleUpdated: true,
            sortRole: 10,
            mandatoryRole: false,
            collabContacts: [],
            collabAddress: [],
            collabHrs: [],
            hrOrderList: [{ id: 0, order: 1, deleted: false }],
            hrHasToBeShown: true,
            deletedHr: 0,
            hrCreated: false,
            roleUpdatedOrder: this.props.roleUpdatedOrder,
            hrCounter: 0,
            noDetailsHrCounter: 0,
            mandatoryCollab: false,
            disabledSaveButton: false,
            order: this.props.order,
        };

        this.handleProp = this.handleProp.bind(this);
        this.handleRoleName = this.handleRoleName.bind(this);
        this.hrOrCompany = this.hrOrCompany.bind(this);
        this.searchCompany = this.searchCompany.bind(this);
        this.handleCollab = this.handleCollab.bind(this);
        this.addHr = this.addHr.bind(this);
        this.saveRole = this.saveRole.bind(this);
        this.sortRole = this.sortRole.bind(this);
        this.deleteRole = this.deleteRole.bind(this);
        this.newOrder = this.newOrder.bind(this);
        this.sendDataRoleSaved = this.sendDataRoleSaved.bind(this);
        this.sendCounterToHandleOffice = this.sendCounterToHandleOffice.bind(this);
        this.sendDataToHandleOffice = this.sendDataToHandleOffice.bind(this);
        this.sendnoDetailsCounterToHandleOffice = this.sendnoDetailsCounterToHandleOffice.bind(this);

        if (this.state.properties.length < 1) {
            //proprietà
            fetch(
                `${SERVER_URL + 'api/translation/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "typeTip": "Property",
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ properties: res.data }, this.setState({ propLoad: false }));
                })
        }
    }

    componentDidUpdate(propsPrecedenti) {
        // Utilizzo tipico (non dimenticarti di comparare le props):
        if (this.props.roleUpdatedOrder !== propsPrecedenti.roleUpdatedOrder) {
            this.setState({ roleUpdatedOrder: this.props.roleUpdatedOrder }, this.saveRole());
        }
       
        if (this.props.order != this.state.order) {
            this.setState({ order: this.props.order }, this.saveRole());
        }
    }

    handleRoleName(event) {
        this.setState({ roleName: event.target.value, mandatoryRole: true, roleUpdated: false, });
        if (event.target.value.length === 0) {
            this.setState({ mandatoryRole: false, roleName: null })
        }
    }

    sortRole(value) {
        this.setState({ sortRole: value });
    }

    handleProp(value) {
        this.setState({ propId: value });
    }

    saveRole(e) {
        //e.preventDefault();
        this.setState({ disabledSaveButton: true })
        if (this.state.roleCreated === false && this.state.isHr === true && this.state.mandatoryRole && this.state.roleName !== null) {
            fetch(
                `${SERVER_URL + "api/role"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.roleName,
                        "Status": this.props.status,
                        "Sort": this.props.order,
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    fetch(
                        `${SERVER_URL + "api/brHrRoleOffice"}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                "officeId": this.state.officeId,
                                "roleId": res.data,
                                "WorkingForHROId": this.state.collabId,
                                "Status": this.props.status,
                                "StartDate": null,
                                "EndDate": null,
                            })
                        }
                    ).then(response => response.json())
                        .then(resp => {
                            this.setState({ basicHroid: resp.data, roleCreated: true, roleId: res.data, roleUpdated: true, roleDeleted: false, disabledSaveButton: false }, this.sendDataRoleSaved)
                        })
                })
        }
        if (this.state.roleCreated === false && this.state.isHr === true && !this.state.mandatoryRole) {
            this.setState({  disabledSaveButton: false })
        }
        if (this.state.roleCreated === false && this.state.isHr === false && this.state.collabId !== '' && this.state.roleName !== '') {
            fetch(
                `${SERVER_URL + "api/role"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.roleName,
                        "Status": this.props.status,
                        "Sort": this.props.order,
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    fetch(
                        `${SERVER_URL + "api/brHrRoleOffice"}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                "officeId": this.state.officeId,
                                "roleId": res.data,
                                "WorkingForHROId": this.state.collabId,
                                "Status": this.props.status,
                                "StartDate": null,
                                "EndDate": null,
                            })
                        }
                    ).then(response => response.json())
                        .then(resp => {
                            this.setState({ basicHroid: resp.data, roleId: res.data, roleCreated: true, roleDeleted: false, roleUpdated: true, disabledSaveButton: false }, this.sendDataRoleSaved)
                        })
                })
        }
        if (this.state.roleCreated === true && this.state.roleName !== '') {
            fetch(
                `${SERVER_URL + "api/role"}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.roleName,
                        'roleid': `${this.state.roleId}`,
                        "Status": this.props.status,
                        "Sort": this.props.order,
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ loading: false, roleUpdated: true, disabledSaveButton: false });
                })
            this.sendDataRoleSaved();
        }
        if (this.state.handleCollab === '' && this.state.isHr === true) {
            //stai creando una collab senza aver selezionato una collab
            this.setState({ disabledSaveButton: false })
        }
    }

    newOrder2(order) {
        fetch(
            `${SERVER_URL + "api/role"}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'name': this.state.roleName,
                    'roleid': `${this.state.roleId}`,
                    "Status": this.props.status,
                    "Sort": order
                })
            }
        ).then(response => response.json())
            .then(res => {
            })
    }

    deleteRole() {
        if (this.state.roleCreated) {
            fetch(
                `${SERVER_URL + 'api/role/hard/' + this.state.roleId}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            this.setState({ roleCreated: false, roleDeleted: true, roleName: '', roleCreated: false, isHr: true, disabledSaveButton: false });
            this.sendCounterToHandleOffice();
            this.sendDataToHandleOffice(this.props.i)
        }
    }

    hrOrCompany(event) {
        this.setState({ isHr: event });
    }

    addHr() {
        if (this.state.mandatoryRole) {
            var newId = this.state.newHrId
            let lunghezza = this.state.hrOrderList.length
            let lastElementId = parseInt(lunghezza) - 1

            this.state.hrOrderList.push({ id: lunghezza, order: lunghezza + 1, deleted: false })


            if (this.state.deletedHr > 0) {

                let newOrderList = this.state.hrOrderList;
                newOrderList[lastElementId].order = parseInt(newOrderList[lastElementId].order) - parseInt(this.state.deletedHr);
                newOrderList.map(el => {
                    if (el.deleted == true) {
                        el.order = -1;
                    }
                })
                this.setState({ hrOrderList: newOrderList })
            }

            let counter = this.state.hrCounter + 1

            this.setState({ newHrId: this.state.newHrId + 1, hrCreated: false, hrCounter: counter });
            this.state.newHr.push(`${newId}`)

        }
    }

    searchCompany(value) {
        if (value.length >= 3 || value.length === 0) {
            fetch(
                `${SERVER_URL + 'api/company/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CompanyName": `${value}`,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 15,
                        "TypologyName": "Company",
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ companies: res.data });
                    } else {
                        this.setState({ loading: false, companies: [] });
                        //non trova la comp
                    }
                })
            if (value.length == 0) {
                this.setState({ mandatoryCollab: false })
            }
        }
    }

    handleCollab(value) {
        fetch(
            `${SERVER_URL + 'api/company/' + value}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => response.json())
            .then(res => {
                let hrs = []
                if (res.data.offices.length > 0) {

                    res.data.offices.map(off => {
                        off.brHrRoleOfficies.map((br, i) => {
                            if (br.hrId != null || i == 0) {
                                hrs.push(br)
                            } else if (br.roleId != null && br.brHrRoleOfficeContacts.length > 0) {
                                hrs.push(br)
                            }
                        })
                    })

                    let contacts = res.data.offices[0].brHrRoleOfficies[0].contacts

                    let addresses = []

                    res.data.offices.map(off => {
                        off.addresses.map(add => {
                            add.office = off,
                            addresses.push(add)
                        })
                    })

                    let listone = []
                    let x = hrs.length
                    let y = x + 1

                    hrs.map((el, i) => {
                        let num = i + 1
                        listone.push({ id: i, order: num, deleted: false })
                    })

                    listone.push({ id: x, order: y, deleted: false })

                    this.setState({ collabContacts: contacts, collabHrs: hrs, collabAddress: addresses, mandatoryCollab: true, hrOrderList: listone, newHr: [] })


                    fetch(
                        `${SERVER_URL + 'api/brHrRoleOffice/list'}`, {
                            method: 'POST',
                            headers: {
                                'Authorization': `Bearer ${this.state.user}`,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                "officeId": res.data.offices[0].officeId,
                                "hrId": null,
                                "page": 1,
                                "totalPages": 0,
                                "totalItems": 0,
                                "pageSize": 999,
                                "pageSizeOptions": null,
                                "firstItemNumber": 0,
                                "lastItemNumber": 0,
                                "entityId": 0
                            })
                        }
                    ).then(response => response.json())
                        .then(newres => {
                            newres.data.map(n => {
                                if (n.hrId == null && n.roleId == null && n.WorkingForHROId == null) {
                                    this.setState({ collabId: n.hroId })
                                }
                            })
                        })
                } else {
                    //crea office
                    fetch(
                        `${SERVER_URL + "api/office"}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                'name': 'Sede Principale',
                                'companyId': value,
                                "isPrincipal": true,
                                'sort': 1,
                                "Status": 1
                            })
                        }
                    ).then(response => response.json())
                        .then(res => {
                            //creo la combo col solo office
                            fetch(
                                `${SERVER_URL + "api/brHrRoleOffice"}`, {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${this.state.user}`
                                    },
                                    body: JSON.stringify({
                                        'officeId': `${res.data}`,
                                    })
                                }
                            ).then(response => response.json())
                                .then(res => {
                                    this.setState({ collabId: res.data })
                                })
                        })
                }
            }
            )
    }

    sendCounterToHandleOffice = () => {
        this.props.parentCounterDeletedRole(1);
    }

    sendnoDetailsCounterToHandleOffice = (childData) => {
        this.setState({ noDetailsHrCounter: childData })
    }

    sendDataToHandleOffice = () => {
        this.props.showOrderButtons(false, this.props.i);
    }

    showOrderButtons = (hrData, id) => {
        if (this.state.hrOrderList[id]) {
            this.state.hrOrderList[id].deleted = true;
        }
        this.setState({ hrHasToBeShown: hrData })
    }

    counterDeletedHr = (childData) => {
        let hrdeleted = parseInt(this.state.deletedHr)
        let counter = hrdeleted + childData;
        this.setState({ deletedHr: counter })

    }

    orderDown(index) {
        if (this.state.hrOrderList[index].order !== 1) {
            let newOrderList = this.state.hrOrderList;
            var indexOrder = newOrderList.findIndex(obj => obj.order == this.state.hrOrderList[index].order - 1);
            newOrderList[index].order = this.state.hrOrderList[index].order - 1;
            newOrderList[indexOrder].order = this.state.hrOrderList[indexOrder].order + 1;
            this.setState({ hrOrderList: newOrderList })
        }
    }

    orderUp(index) {
        if (this.state.hrOrderList.length > this.state.hrOrderList[index].order) {
            let newOrderList = this.state.hrOrderList;
            var indexOrder = newOrderList.findIndex(obj => obj.order == this.state.hrOrderList[index].order + 1);
            newOrderList[index].order = this.state.hrOrderList[index].order + 1;
            newOrderList[indexOrder].order = this.state.hrOrderList[indexOrder].order - 1;
            this.setState({ hrOrderList: newOrderList })
        }
    }

    newOrder(i) {
        if (typeof this.state.hrOrderList[i] !== 'undefined') {
            HandleHr.newOrder(this.state.hrOrderList[i].order)
        }
    }

    callbackHrCreatedFunction = (childData) => {
        this.setState({ hrCreated: childData })
    }

    sendDataRoleSaved = () => {
        this.props.parentCallbackRoleSaved(true);
    }

    callbackOrder = (childData) => {
        var i;
        for (i = 0; i < childData; i++) {
            this.orderDown(childData)
        }

    }

    render() {

        let mandatoryCollab = this.state.isHr ? "" : !this.state.mandatoryCollab ? <Tooltip title="This field is mandatory"><Icon style={{ marginTop: '36px' }} type="exclamation-circle" /></Tooltip> : <Icon style={{ marginTop: '36px' }} type="check-circle" />

        let mandatory1 = !this.state.mandatoryRole ? <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip> : <Icon type="check-circle" />

        let hrOrCompany = this.state.isHr ? <Avatar shape="square" size={70} icon="user" /> : <Avatar shape="square" size={70} icon="solution" />

        let mandatoryAreNotMet = <p>One or more mandatory fields are empty</p>

        let allSaved = <p>Everything is already Saved</p>

        let isRoleSavable = !this.state.isHr ?
            this.state.mandatoryCollab && this.state.mandatoryRole ?
                this.state.roleUpdated ?
                    <Popover content={allSaved}> <Button disabled className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button></Popover> :
                    <Button disabled={this.state.disabledSaveButton} onClick={this.saveRole} className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button> :
                <Popover content={mandatoryAreNotMet}> <Button disabled className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button></Popover> :
            this.state.mandatoryRole ?
                this.state.roleUpdated ?
                    <Popover content={allSaved}> <Button disabled className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button></Popover> :
                <Button disabled={this.state.disabledSaveButton} onClick={this.saveRole} className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button> :
                <Popover content={mandatoryAreNotMet}> <Button disabled className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button></Popover>

        let listacompany = this.state.companies.map(comp =>
            <Option key={comp.companyId}>{comp.name}</Option>
        )

        let roleDelete = this.state.roleCreated ? <Popconfirm placement="top" title="Are you sure you want to delete this Role, given that the HR will not be deleted?" onConfirm={this.deleteRole} okText="Yes" cancelText="No"><Button className="deleteButtonHrWizard deleteRole"><Icon type="close" />Delete Role</Button></Popconfirm> : <Button disabled className="deleteButtonHrWizard deleteRole"><Icon type="close" />Delete Role</Button>

        let compOrHr = this.state.isHr ? '' :
            <div style={{ width: '100%', display: 'inline-flex' }}>
                <AutoComplete
                    dataSource={listacompany}
                    style={{ width: 'calc(100% - 32px)', marginTop: '20px', marginRight: '14px' }}
                    onSelect={this.handleCollab}
                    onChange={this.searchCompany}
                    placeholder="Collaboration"
                    disabled={this.state.roleCreated}
                />
                {mandatoryCollab}
            </div>

        let ifRoleOk = this.state.roleCreated ?
            <ul style={{ padding: '0', display: 'flex', flexDirection: 'column', listStyle: "none" }}>

                {this.state.collabHrs.map((br, i) => {
                    var num = parseInt(i, 10);
                    let x = parseInt(i) + 1;

                    let addresses = i == 0 ? this.state.collabAddress : null

                    var index = this.state.hrOrderList.findIndex(obj => obj.id == i);
                    let hrNotDeleted = !this.state.hrOrderList[num].deleted ?
                        <div>
                            <div className="orderArrowsHr">
                                {<Button className="hrOrderButton" type="primary" icon="caret-up" onClick={() => this.orderDown(index)} />}
                                <br />
                                <div className="hrOrderNumber">{this.state.hrOrderList[index].order}</div>
                                <br />
                                {<Button className="hrOrderButton" type="primary" icon="caret-down" onClick={() => this.orderUp(index)} />}
                            </div>
                            <HandleHr parentCallbackOrder={this.callbackOrder} noDetailsHrCounter={this.state.noDetailsHrCounter} hrCounter={this.state.hrCounter} addresses={addresses} callbackHrIsCreated={this.callbackHrCreatedFunction} parentnoDetailsCounter={this.sendnoDetailsCounterToHandleOffice} parentCounterDeletedHr={this.counterDeletedHr} showOrderButtons={this.showOrderButtons} handleId={this.state.hrOrderList[index].id} newOrder={() => this.newOrder(i)} status={this.props.status} order={this.state.hrOrderList[index].order} status={this.props.status} collabContacts={br.brHrRoleOfficeContacts} collabHrs={br.hr} collab={br} collabId={this.state.collabId} basicHroid={this.state.basicHroid} i={num} key={br.hrId} isHr={this.state.isHr} properties={this.state.properties} roleId={this.state.roleId} officeId={this.state.officeId} roleStatus={this.state.roleCreated} user={this.state.user} />
                        </div> : ""
                    return (
                        <li key={x} style={{ order: this.state.hrOrderList[index].order }}>
                            {hrNotDeleted}
                        </li>
                    )
                })}

                {this.state.newHr.map((el, i) => {
                    var collabNum = this.state.collabHrs.length
                    var num = parseInt(i, 10) + collabNum;
                    let x = parseInt(i) + 1 + collabNum;
                    var index = this.state.hrOrderList.findIndex(obj => obj.id == num);
                    let hrNotDeleted = !this.state.hrOrderList[num].deleted ?
                        <div>
                            <div className="orderArrowsHr">
                                {<Button className="hrOrderButton" type="primary" icon="caret-up" onClick={() => this.orderDown(index)} />}
                                <br />
                                <div className="hrOrderNumber">{this.state.hrOrderList[index].order}</div>
                                <br />
                                {<Button className="hrOrderButton" type="primary" icon="caret-down" onClick={() => this.orderUp(index)} />}
                            </div>
                            <HandleHr parentCallbackOrder={this.callbackOrder} noDetailsHrCounter={this.state.noDetailsHrCounter} hrCounter={this.state.hrCounter} addresses={null} callbackHrIsCreated={this.callbackHrCreatedFunction} parentCounterDeletedHr={this.counterDeletedHr} parentnoDetailsCounter={this.sendnoDetailsCounterToHandleOffice} showOrderButtons={this.showOrderButtons} handleId={this.state.hrOrderList[index].id} newOrder={() => this.newOrder(i)} status={this.props.status} order={this.state.hrOrderList[index].order} collabContacts={[]} collabHrs={null} collabId={this.state.collabId} basicHroid={this.state.basicHroid} i={num} isHr={this.state.isHr} properties={this.state.properties} roleId={this.state.roleId} officeId={this.state.officeId} roleStatus={this.state.roleCreated} user={this.state.user} />
                        </div> : ""
                    return (
                        <li key={x} style={{ order: this.state.hrOrderList[index].order }}>
                            {hrNotDeleted}
                        </li>
                    )
                })}

            </ul> : ""

        let addNewHr = !this.state.roleCreated ? "" : this.state.hrCreated ? <Button onClick={this.addHr} className="createHrButton" icon="plus">Hr</Button> : <Button disabled onClick={this.addHr} className="createHrButton" icon="plus">Hr</Button>

        let switchCollab = this.state.roleCreated ? '' :
            <Switch
                className="hrOrCompany"
                checkedChildren="Person"
                unCheckedChildren="Collaborations"
                defaultChecked
                onChange={this.hrOrCompany}
                value={this.state.isHr}
            />

        let showRole = this.state.roleDeleted ? "" :
            <Row className={"wizardHrCreation " + this.state.roleCreated + "classRoleSaved" + this.state.roleUpdated + " marginFF"} id={this.state.officeId + "roleBox" + this.props.order} name={this.state.officeId + "roleBox" + this.props.order} style={{ marginTop: '-120px' }}>
                <Col xl="12" className="handleRoleBox">
                    <div style={{ width: '100%', height: 'auto' }} className="wizardSelect">
                        {hrOrCompany}
                        {switchCollab}
                        {compOrHr}
                        <Form>

                            <Tooltip placement="topLeft" title="Insert here the role name for one or more HRs">
                                <h4><Icon type="info-circle" /> Role name:</h4>
                            </Tooltip>
                            <Input autoComplete="new-password" value={this.state.roleName} className="contactText" className={this.state.roleCreated + "classRoleSaved" + this.state.roleUpdated} style={{ width: 'calc(100% - 32px)', marginRight: '14px', height: '100%' }} allowClear={true} placeholder="Role" onChange={this.handleRoleName} />
                            {mandatory1}
                        </Form>

                        <div>
                            {ifRoleOk}
                        </div>
                        {addNewHr}
                    </div>
                    <div style={{ display: 'inline-flex', width: '100%' }}>
                        <div className="pulsantiRole" style={{ display: 'inline-flex' }}>
                            {isRoleSavable}
                            {roleDelete}
                        </div>
                    </div>
                </Col>
            </Row>

        return (
            <div>
                {showRole}
            </div>
        );
    }
}

export default HandleRole;


// WEBPACK FOOTER //
// ./src/Wizard/HandleRole.js